import React from "react";
import LetterTemplateDialog from "../../documents/LetterTemplateDialog";

const LetterCustomization = (props) => {

  return (
    <>
      <div className="container">
        <LetterTemplateDialog />
      </div>
    </>
  );
};
export default LetterCustomization;
